import { decodeClubRouteKey } from './club-route-key';

function clubQueryString(clubRouteKey: string | null | undefined): string {
  const d = decodeClubRouteKey(clubRouteKey);
  const params = new URLSearchParams();
  if (d.bookingSlug) params.set('bookingSlug', d.bookingSlug);
  else if (d.clubId) params.set('clubId', d.clubId);
  else if (d.clubNumber) params.set('clubNumber', d.clubNumber);
  return params.toString();
}

export function bookPathFromClubRouteKey(clubRouteKey: string | null | undefined): string {
  const d = decodeClubRouteKey(clubRouteKey);
  if (d.bookingSlug) return `/${d.bookingSlug}`;
  const qs = clubQueryString(clubRouteKey);
  return qs ? `/?${qs}` : '/';
}

export function shopPathFromClubRouteKey(clubRouteKey: string | null | undefined): string {
  const d = decodeClubRouteKey(clubRouteKey);
  if (d.bookingSlug) return `/${d.bookingSlug}/shop`;
  const qs = clubQueryString(clubRouteKey);
  return qs ? `/shop?${qs}` : '/shop';
}
